<div mat-dialog-content id="error" dir="ltr" style="white-space: pre;">{{error}}</div>
<div mat-dialog-actions fxLayout="row wrap" fxLayoutAlign="center center" class="margin-tb-1">
  <button mat-raised-button color="primary" (click)="closeDialog()">{{'close' | translate}}</button>
  <button mat-raised-button color="primary" (click)="copy()"><i class="fas fa-copy"></i></button>
</div>